import React, { Component } from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import ImageCard from './draggableImageCard';
import {GridList, GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

@DragDropContext(HTML5Backend)
export default class DraggableImagesContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
    this.state.images = props.images;

    this.deletePicture = this.deletePicture.bind(this);    
  }

  moveImage(dragIndex, hoverIndex) {
    const { images } = this.state;
    const dragImage = images[dragIndex];

    images.splice(dragIndex, 1);
    images.splice(hoverIndex, 0, dragImage);

    this.setState({
      images: images,
    });
  }

  deletePicture(image){
    image.State = 'deleted';
    this.setState({
      currentEntity: this.state.currentEntity
    });    
  }  

  render() {
    const { images } = this.state;
    return (
      <GridList cellHeight={75}>
        {images.filter((image) => {
            return (!image.State || image.State !== 'deleted');
          }).map((image, i) => (
          <ImageCard
            key={image.ID}
            index={i}
            image={image}
            deletePictureAction={this.deletePicture}
            moveImage={(dragIndex, hoverIndex) => this.moveImage(dragIndex, hoverIndex)}
          />
        ))}
      </GridList>
    );
  }  
}


/** WEBPACK FOOTER **
 ** ./src/app/components/draggableImagesContainer.js
 **/